import { Injectable } from '@angular/core';

import { DeviceModel } from '@shure/shared/angular/data-access/system-api/models';
import { DeviceBehaviorPluginsService } from '@shure/shared/angular/device-behavior/core';

import { LightsImage } from '../plugin';
import { LightsImageProvider } from '../providers';

@Injectable()
export class DeviceLightsBehaviorPluginService implements LightsImageProvider {
	constructor(private readonly plugins: DeviceBehaviorPluginsService) {}

	public getLightsImage(model: DeviceModel): LightsImage | undefined {
		return this.plugins.get<LightsImageProvider>(model)?.getLightsImage(model);
	}
}
